export default __webpack_public_path__ + "static/media/icon-chevron-blue.d27e181e.svg";